import { jwtDecode, JwtPayload } from "jwt-decode";

/**
 * Check if the JWT token in localStorage is expired.
 * If expired, clears auth data and redirects to login.
 * Returns true if token was expired/invalid, false if still valid or no token.
 */
export function checkTokenExpiry(): boolean {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode<JwtPayload>(token);

    // exp is in seconds, Date.now() is in milliseconds
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      // Token is expired — clear auth data and redirect
      clearAuthData();
      window.location.replace("/auth-pages/login");
      return true;
    }

    return false;
  } catch {
    // Invalid token format — clear and redirect
    clearAuthData();
    window.location.replace("/auth-pages/login");
    return true;
  }
}

/**
 * Clear all authentication data from localStorage.
 */
export function clearAuthData(): void {
  localStorage.removeItem("token");
  localStorage.removeItem("menu");
  localStorage.removeItem("userdata");
  localStorage.removeItem("facit_authUsername");
}
